export const PayVaultAPIFormKeys = {
    cardNumber: 'card-number',
    expirationMonth: 'expiration-month',
    expirationYear: 'expiration-year',
    form: 'form',
};
